// Public client config that differs per environment.
//
// In the nginx image, /env.js is generated at container start from the
// container's environment (docker/40-env-js.sh), so one image serves local, dev
// and prod. Under `npm start` the committed public/env.js is empty and the
// REACT_APP_* variables from the dev server's environment are used instead.
const runtime = (typeof window !== 'undefined' && window.__ENV__) || {};

export const GOOGLE_CLIENT_ID =
  runtime.GOOGLE_CLIENT_ID || process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

export const STRIPE_PUBLISHABLE_KEY =
  runtime.STRIPE_PUBLISHABLE_KEY || process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
